import { render, staticRenderFns } from "./OverflowTextTooltip.vue?vue&type=template&id=65210a46&scoped=true&lang=pug&"
import script from "./OverflowTextTooltip.vue?vue&type=script&lang=ts&"
export * from "./OverflowTextTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./OverflowTextTooltip.vue?vue&type=style&index=0&id=65210a46&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65210a46",
  null
  
)

export default component.exports